
{
  "familyId": "SWW-VD-STERK",
  "questions": [
    {
      "id": "SWW-VD-STERK-001",
      "familyId": "SWW-VD-STERK",
      "module": "SpellingWW",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_sterk",
      "questionType": "multiple_choice",
      "question": "Wat is het voltooid deelwoord van 'lopen'?",
      "context": null,
      "options": ["gelopen", "geloopt", "geloopen", "gelopd"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "verbTable",
          "data": {
            "verb": "lopen",
            "type": "sterk",
            "forms": { "tt": ["loop", "loopt", "loopt", "lopen"], "vt": ["liep", "liep", "liep", "liepen"], "vd": ["gelopen"] },
            "label": "Sterk werkwoord: lopen"
          }
        }
      ],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "VD van sterke werkwoorden", "content": "Sterke werkwoorden veranderen van klinker in de verleden tijd. Het VD eindigt op -en (niet op -t of -d).\n\nlopen → liep → gelopen\nschrijven → schreef → geschreven\n\nPatroon: ge- + veranderde stam + -en", "icon": "lightbulb" } }
      ],
      "conceptId": "vd_sterk_lopen",
      "variantIndex": 1,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "'Lopen' is een sterk werkwoord: lopen → liep → gelopen. Het VD eindigt op -en. Onthoud: bij sterke werkwoorden gebruik je NOOIT 't kofschip voor het VD.",
        "solutionSteps": ["Lopen is een sterk werkwoord", "VT: liep (klinkerverandering)", "VD: ge- + lop + -en = gelopen ✓"],
        "distractorExplanations": {
          "0": "Goed! Gelopen — sterk werkwoord, VD eindigt op -en.",
          "1": "'Geloopt' behandelt 'lopen' als zwak werkwoord met kofschip. Maar 'lopen' is sterk (liep, gelopen). Onthoud: sterke VD's eindigen op -en.",
          "2": "'Geloopen' heeft een dubbele 'o'. Maar in het VD schrijf je 'gelopen' met één 'o'. De klinker verandert niet in het VD.",
          "3": "'Gelopd' bestaat niet. Sterke werkwoorden eindigen op -en in het VD, niet op -d."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "sww.vd-sterk-als-zwak", "label": "Sterk werkwoord behandeld als zwak (kofschip)", "optionIndex": 1 },
          { "id": "sww.vd-dubbele-klinker", "label": "Dubbele klinker in VD", "optionIndex": 2 },
          { "id": "sww.vd-verkeerde-uitgang", "label": "VD op -d i.p.v. -en", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-VD-STERK-002",
      "familyId": "SWW-VD-STERK",
      "module": "SpellingWW",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_sterk",
      "questionType": "multiple_choice",
      "question": "Welke zin is correct?",
      "context": null,
      "options": [
        "Hij heeft het boek geschreven.",
        "Hij heeft het boek geschrijft.",
        "Hij heeft het boek geschrijfd.",
        "Hij heeft het boek geschreeft."
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "verbTable",
          "data": { "verb": "schrijven", "type": "sterk", "forms": { "tt": ["schrijf", "schrijft", "schrijft", "schrijven"], "vt": ["schreef", "schreef", "schreef", "schreven"], "vd": ["geschreven"] }, "label": "Sterk werkwoord: schrijven" }
        }
      ],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Schrijven → geschreven", "content": "Schrijven is een sterk werkwoord:\nschrijven → schreef → geschreven\n\nHet VD eindigt op -en. De klinker verandert: ij → e.", "icon": "lightbulb" } }
      ],
      "conceptId": "vd_sterk_schrijven",
      "variantIndex": 2,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Schrijven → schreef → geschreven. Het VD van sterke werkwoorden eindigt op -en. De klinker verandert (ij → e). Zet om naar de ik-vorm om te checken: ik heb geschreven ✓.",
        "solutionSteps": ["Schrijven is sterk (schreef)", "VD: ge- + schrev + -en = geschreven", "Klinkerverandering: ij → e", "Check: ik heb geschreven ✓"],
        "distractorExplanations": {
          "0": "Goed! 'Geschreven' — sterk werkwoord, VD op -en.",
          "1": "Je behandelde 'schrijven' als zwak werkwoord. Maar 'schrijven' is sterk (schreef, geschreven). Sterke VD's eindigen op -en, niet op -t.",
          "2": "Het VD van sterke werkwoorden eindigt op -en, niet op -d. Onthoud: geschreven, niet geschrijfd.",
          "3": "Je combineerde de VT-vorm (schreef) met -t. Maar het VD is een aparte vorm: geschreven. VT = schreef, VD = geschreven."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.vd-sterk-als-zwak", "label": "Sterk werkwoord behandeld als zwak", "optionIndex": 1 },
          { "id": "sww.vd-verkeerde-uitgang", "label": "VD op -d i.p.v. -en", "optionIndex": 2 },
          { "id": "sww.vd-vt-vd-verwarring", "label": "VT-vorm en VD-vorm verward", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-VD-STERK-003",
      "familyId": "SWW-VD-STERK",
      "module": "SpellingWW",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_sterk",
      "questionType": "multiple_choice",
      "question": "Wat is het voltooid deelwoord van 'rijden'?",
      "context": null,
      "options": ["gereden", "gerijdt", "gerijd", "gerijden"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "verbTable",
          "data": { "verb": "rijden", "type": "sterk", "forms": { "tt": ["rijd", "rijdt", "rijdt", "rijden"], "vt": ["reed", "reed", "reed", "reden"], "vd": ["gereden"] }, "label": "Sterk werkwoord: rijden" }
        }
      ],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Rijden → gereden", "content": "Rijden is sterk: rijden → reed → gereden.\nDe klinker verandert: ij → e.\nVD eindigt op -en.", "icon": "lightbulb" } }
      ],
      "conceptId": "vd_sterk_rijden",
      "variantIndex": 3,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Rijden → reed → gereden. Sterk werkwoord met klinkerverandering (ij → e). VD eindigt op -en. Zet om naar de ik-vorm: ik heb gereden ✓.",
        "solutionSteps": ["Rijden is sterk (reed)", "Klinkerverandering: ij → e", "VD: ge- + red + -en = gereden ✓"],
        "distractorExplanations": {
          "0": "Goed! 'Gereden' — klinkerverandering ij → e, VD op -en.",
          "1": "Je behandelde 'rijden' als zwak werkwoord. Maar 'rijden' is sterk (reed, gereden). Sterke VD's eindigen op -en, niet op -t.",
          "2": "Het VD van sterke werkwoorden eindigt altijd op -en. Onthoud: gereden, niet gerijd.",
          "3": "De oorspronkelijke klinker (ij) verandert bij sterke werkwoorden. Bij rijden: ij → e. Onthoud: gereden, niet gerijden."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "sww.vd-sterk-als-zwak", "label": "Sterk werkwoord behandeld als zwak", "optionIndex": 1 },
          { "id": "sww.vd-verkeerde-uitgang", "label": "VD zonder -en uitgang", "optionIndex": 2 },
          { "id": "sww.vd-klinker-niet-veranderd", "label": "Oorspronkelijke klinker behouden in VD", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-VD-STERK-004",
      "familyId": "SWW-VD-STERK",
      "module": "SpellingWW",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_sterk",
      "questionType": "multiple_choice",
      "question": "Welk werkwoord heeft een STERK voltooid deelwoord (eindigt op -en)?",
      "context": null,
      "options": ["zwemmen (gezwommen)", "fietsen (gefietst)", "werken (gewerkt)", "koken (gekookt)"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Sterk vs. zwak herkennen", "content": "Sterk VD: eindigt op -en (gelopen, geschreven, gezwommen)\nZwak VD: eindigt op -t of -d (gefietst, gewerkt, gekookt)\n\nTip: als de klinker verandert in de VT, is het sterk.", "icon": "lightbulb" } }
      ],
      "conceptId": "vd_sterk_herkennen",
      "variantIndex": 4,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Zwemmen → zwom → gezwommen. De klinker verandert (e → o) en het VD eindigt op -en → sterk. De andere drie zijn zwak: gefietst, gewerkt, gekookt (VD op -t).",
        "solutionSteps": ["Zwemmen: zwom (klinkerverandering) → sterk", "VD: gezwommen (op -en)", "Fietsen/werken/koken: geen klinkerverandering → zwak ✓"],
        "distractorExplanations": {
          "0": "Goed! Gezwommen eindigt op -en → sterk werkwoord.",
          "1": "Gefietst eindigt op -t → zwak werkwoord (kofschip: 's').",
          "2": "Gewerkt eindigt op -t → zwak werkwoord (kofschip: 'k').",
          "3": "Gekookt eindigt op -t → zwak werkwoord (kofschip: 'k')."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.sterk-zwak-verwarring", "label": "Zwak werkwoord aangezien voor sterk", "optionIndex": 1 },
          { "id": "sww.sterk-zwak-verwarring", "label": "Zwak werkwoord aangezien voor sterk", "optionIndex": 2 },
          { "id": "sww.sterk-zwak-verwarring", "label": "Zwak werkwoord aangezien voor sterk", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-VD-STERK-005",
      "familyId": "SWW-VD-STERK",
      "module": "SpellingWW",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_sterk",
      "questionType": "fill_in",
      "question": "Vul het voltooid deelwoord in: 'Zij heeft de hele dag ... (zingen).' Typ het woord.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["gezongen"],
        "caseSensitive": false,
        "placeholder": "ge..."
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Zingen → gezongen", "content": "Zingen is sterk: zingen → zong → gezongen.\nKlinkerverandering: i → o.\nVD: ge- + zong + -en = gezongen.", "icon": "lightbulb" } },
        { "type": "verbTable", "showWhen": "wrong", "data": { "verb": "zingen", "type": "sterk", "forms": { "tt": ["zing", "zingt", "zingt", "zingen"], "vt": ["zong", "zong", "zong", "zongen"], "vd": ["gezongen"] }, "label": "Sterk werkwoord: zingen (i → o)" } }
      ],
      "conceptId": "vd_sterk_zingen_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Zingen → zong → gezongen. Sterk werkwoord: klinkerverandering i → o, VD eindigt op -en.",
        "solutionSteps": ["Zingen is sterk (zong)", "VD: ge- + zong + -en = gezongen ✓"]
      },
      "pedagogy": {
        "dok": 1,
        "hasStructuredData": true
      }
    },
    {
      "id": "SWW-VD-STERK-006",
      "familyId": "SWW-VD-STERK",
      "module": "SpellingWW",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_sterk",
      "questionType": "sentence_error_judge",
      "question": "In welke zin staat een fout bij het voltooid deelwoord? Klik op de fout.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "sentences": [
          { "text": "Zij heeft de hele dag geschrijft.", "hasError": true, "correction": "geschreven", "explanation": "'Schrijven' is een sterk werkwoord: het VD is 'geschreven' (op -en), niet 'geschrijft' (op -t)." },
          { "text": "Hij heeft hard gelopen.", "hasError": false },
          { "text": "Wij hebben lang gezwommen.", "hasError": false },
          { "text": "Ik heb een brief geschreven.", "hasError": false }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Sterk VD eindigt op -en", "content": "Sterke werkwoorden hebben een VD dat eindigt op -en: geschreven, gelopen, gezwommen. NIET op -t of -d. 'Geschrijft' is fout — het moet 'geschreven' zijn.", "icon": "lightbulb" } },
        { "type": "verbTable", "showWhen": "wrong", "data": { "verb": "schrijven", "type": "sterk", "forms": { "tt": ["schrijf", "schrijft", "schrijft", "schrijven"], "vt": ["schreef", "schreef", "schreef", "schreven"], "vd": ["geschreven"] }, "label": "Sterk werkwoord: schrijven (ij → e)" } }
      ],
      "conceptId": "vd_sterk_error",
      "variantIndex": 6,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "'Geschrijft' is fout. 'Schrijven' is een sterk werkwoord: schrijven → schreef → geschreven. Het VD eindigt op -en, niet op -t. De andere zinnen zijn correct: gelopen, gezwommen, geschreven.",
        "solutionSteps": [
          "Geschrijft → FOUT: schrijven is sterk → geschreven (op -en)",
          "Gelopen → goed (lopen → gelopen)",
          "Gezwommen → goed (zwemmen → gezwommen)",
          "Geschreven → goed (schrijven → geschreven) ✓"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "hasStructuredData": true
      }
    },
    {
      "id": "SWW-VD-STERK-007",
      "familyId": "SWW-VD-STERK",
      "module": "SpellingWW",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_sterk",
      "questionType": "matching",
      "question": "Koppel elk sterk werkwoord aan het juiste voltooid deelwoord.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "lopen", "right": "gelopen" },
          { "left": "schrijven", "right": "geschreven" },
          { "left": "rijden", "right": "gereden" },
          { "left": "zingen", "right": "gezongen" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Sterke VD's", "content": "Sterke werkwoorden veranderen van klinker en het VD eindigt op -en: lopen → gelopen, schrijven → geschreven, rijden → gereden, zingen → gezongen.", "icon": "lightbulb" } }
      ],
      "conceptId": "vd_sterk_matching",
      "variantIndex": 7,
      "citoDifficulty": 0.26,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Lopen → gelopen, schrijven → geschreven (ij→e), rijden → gereden (ij → e), zingen → gezongen (i → o). Alle VD's eindigen op -en.",
        "solutionSteps": [
          "Lopen → gelopen",
          "Schrijven → geschreven (ij → e)",
          "Rijden → gereden (ij → e)",
          "Zingen → gezongen (i → o) ✓"
        ]
      },
      "pedagogy": {
        "dok": 1,
        "hasStructuredData": true
      }
    },
    {
      "id": "SWW-VD-STERK-008",
      "familyId": "SWW-VD-STERK",
      "module": "SpellingWW",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_sterk",
      "questionType": "verb_conjugation_flow",
      "question": "Vervoeg 'schrijven' naar het voltooid deelwoord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "verb": "schrijven",
        "targetForm": "voltooid deelwoord",
        "context": "Zij heeft een brief ... (schrijven)",
        "finalAnswer": "geschreven",
        "steps": [
          {
            "id": "step1",
            "prompt": "Sterk of zwak werkwoord?",
            "type": "choice",
            "options": [
              { "label": "Sterk (klinker verandert)", "value": "sterk", "isCorrect": true },
              { "label": "Zwak (kofschip-regel)", "value": "zwak", "isCorrect": false, "feedback": "'Schrijven' is een sterk werkwoord: de klinker verandert (ij → e). Geen kofschip-regel." }
            ]
          },
          {
            "id": "step2",
            "prompt": "Vul het voltooid deelwoord in: Zij heeft een brief ...",
            "type": "input",
            "acceptedAnswers": ["geschreven"]
          }
        ]
      },
      "stimulusAids": [
        {
          "type": "verbTable",
          "data": { "verb": "schrijven", "type": "sterk", "forms": { "vt": ["schreef", "schreef", "schreef", "schreven"], "vd": ["geschreven"] }, "hulpww": "hebben", "label": "Sterk werkwoord: ij → e, VD eindigt op -en" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Sterke werkwoorden",
            "content": "Sterke werkwoorden veranderen van klinker en het VD eindigt op -en (niet op -t/-d). Schrijven (ij) → geschreven (e). Geen kofschip-regel.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "vd_sterk_flow",
      "variantIndex": 8,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Stap 1: schrijven is een sterk werkwoord — de klinker verandert (ij → e). Stap 2: VD = geschreven (eindigt op -en). Hulpwerkwoord: heeft (geen beweging).",
        "solutionSteps": [
          "Sterk werkwoord: klinker verandert (ij → e)",
          "VD eindigt op -en, niet op -t/-d",
          "schrijven → geschreven"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.strong-as-weak", "label": "Sterk werkwoord behandeld als zwak (kofschip toegepast)" }
        ]
      }
    }
  ]
}
